import React, {useState, useEffect, useRef} from 'react'
import DataView from '../../../../UI/Dashboard/DataView'
import Ajax from '../../../../../helpers/Ajax'
import { useParams, useNavigate } from 'react-router-dom'
import FormGroup from '../../../../UI/Form/FormGroup'
import ErrorField from '../../../../UI/Form/ErrorField'
import { Formik, Field, Form, ErrorMessage } from 'formik'
import * as Yup from 'yup'
import DataLoader from '../../../../UI/Dashboard/DataLoader'
import Button from '../../../../UI/Form/Button'
import ContentLayout from '../../../../Common/ContentLayout'
import { toast } from 'react-toastify'
import { Helmet } from 'react-helmet-async'
import GetState from '../../../../../helpers/GetState'
import GetCity from '../../../../../helpers/GetCity'
import InputChip from '../../../../UI/Dashboard/inputChip'

export default function AddLocation() {
    const [states, setStates] = useState(null)
    const [city, setCity] = useState(null)
    const [selectedState, setSelectedState] = useState('')
    const [pocLegalEmail, setPocLegalEmail] = useState([])
    const [pocCrmEmail, setPocCrmEmail] = useState([])
    const [pocFinanceEmail, setPocFinanceEmail] = useState([])
    const urlParams = useParams()
    const navigate = useNavigate()
    const dataIcon = useRef()

    useEffect(()=>{
        const getResponse = setTimeout(function(){
            (async()=>{
                const stateList = await GetState()
                setStates(stateList)
            })()
          },100)
      
          return()=>{
            clearInterval(getResponse)
          }
    },[])

    //Seelct State for City
    const chooseState = async(e) => {
        var stateId = e.target.value
        setSelectedState(stateId)
        const cityFetch = await GetCity(stateId)
        setCity(cityFetch)
    }

    const addData = async (values, event) => {
        if(selectedState === ''){
            toast.error('Please select state!',{
                toastId: 'stateError',
                autoClose: 1000
            })
        }
        const data = {
            name: values.title, 
            state: selectedState, 
            city : values.city,
            shortCode:values.shortCode,
            pocCrmEmail:pocCrmEmail ?? [],
            pocFinanceEmail:pocFinanceEmail ?? [],
            pocLegalEmail:pocLegalEmail ?? [],
            neighborhoodDescription:values.neighborhoodDescription ?? ""
        }
        if(values.pocCrmMobile) data.pocCrmMobile = values.pocCrmMobile
        if(values.replyToEmail) data.replyToEmail = values.replyToEmail
        const update = await Ajax({
            url: `/setting/location`,
            method: 'POST',
            token: true,
            data: data,
            loader: true
        })
        if(update.data.error){
            toast.error('Something Went Wrong Please Check')
        }
        if(update.data.status === "SUCCESS!"){
            toast.success('Location Added Successfully')
            setTimeout(function(){
                navigate('/admin/property-management/location')
            },500)
        }
    }
    return (
        <ContentLayout title="Add Location">
            <Helmet>
                <title>Add Location</title>
            </Helmet>
            <DataView title="Infomation">
                <Formik
                    initialValues={{ 
                        city:'',
                        title:'',
                        shortCode:'',
                        pocCrmMobile: '',
                        replyToEmail: ''
                    }}
                    validationSchema={Yup.object({
                        city: Yup.string()
                        .required('Field is Required'),
                        title: Yup.string()
                        .required('Field is Required'),
                        shortCode: Yup.string()
                        .required('Field is Required')
                    })}
                    onSubmit={(values, event) => {
                        addData(values, event)
                    }}
                >
                <Form>
                    <div className='row'>
                        <div className='col-md-6'>
                            <FormGroup label="State" required>
                                <select name="state" className='form-select' value={selectedState} onChange={chooseState}>
                                    <option value="" disabled>Select State</option>
                                    {states === null ? <option value='' disabled>Searching...</option> :  states.map(e=>(
                                        <option key={e._id} value={e._id}>{e.name}</option>
                                    ))}
                                </select>
                                <ErrorField><ErrorMessage name="state"/></ErrorField>
                            </FormGroup>
                        </div>
                        <div className='col-md-6'>
                            <FormGroup label="City" required>
                                <Field as="select" name="city" className='form-select'>
                                    <option value="" disabled>Select City</option>
                                    {city === null? <option value='' disabled>Select State</option> :  city.map(e=>(
                                            <option key={e._id} value={e._id}>{e.name}</option>
                                    ))}
                                </Field>
                                <ErrorField><ErrorMessage name="city"/></ErrorField>
                            </FormGroup>
                        </div>
                    </div>
                    <div className='row'>
                    <div className='col-md-6'>
                            <FormGroup label="Title" required>
                                <Field placeholder='Title' name="title" className='form-control' />
                                <ErrorField><ErrorMessage name="title"/></ErrorField>
                            </FormGroup>
                        </div>
                        <div className='col-md-6'>
                            <FormGroup label="Short Code" required>
                                <Field placeholder='Short Code' name="shortCode" className='form-control' />
                                <ErrorField><ErrorMessage name="shortCode"/></ErrorField>
                            </FormGroup>
                        </div>
                   
                    </div>
                    <div className='row'>
                        <div className='col-md-6'>
                            <FormGroup label="Crm Mobile">
                                <Field placeholder='Crm mobile' name="pocCrmMobile" className='form-control' />
                                <ErrorField><ErrorMessage name="pocCrmMobile"/></ErrorField>
                            </FormGroup>
                        </div>
                        <div className='col-md-6'>
                            <FormGroup label="Reply Email">
                                <Field placeholder='Reply Email' name="replyToEmail" className='form-control' />
                                <ErrorField><ErrorMessage name="replyToEmail"/></ErrorField>
                            </FormGroup>
                        </div>
                        <div className='col-md-6' >
                            <FormGroup label="Poc Legal Email">
                            <div className='input-group' style={{border:'solid 1px rgba(0, 0, 0, 0.125)'}}>
                            <InputChip data={pocLegalEmail} action={setPocLegalEmail}/>
                            </div>
                             </FormGroup>
                        </div>
                        <div className='col-md-6' >
                            <FormGroup label="Poc Crm Email">
                            <div className='input-group' style={{border:'solid 1px rgba(0, 0, 0, 0.125)'}}>
                            <InputChip data={pocCrmEmail} action={setPocCrmEmail}/>
                            </div>
                             </FormGroup>
                        </div>
                        <div className='col-md-12 ' >
                            <FormGroup label="Poc Finance Email">
                            <div className='input-group' style={{border:'solid 1px rgba(0, 0, 0, 0.125)'}}>
                            <InputChip data={pocFinanceEmail} action={setPocFinanceEmail}/>
                            </div>
                             </FormGroup>
                        </div>
                        <div className='col-md-12 ' >
                            <FormGroup label="Neighborhood Description">
                                <Field as="textarea" placeholder='Neighborhood Description' name="neighborhoodDescription" className='form-control' />
                                <ErrorField><ErrorMessage name="neighborhoodDescription"/></ErrorField>
                           </FormGroup>
                        </div>
                    </div>
                    <div className='col-md-2 d-grid'>
                        <Button type="submit">Add</Button>
                    </div>
                </Form>
                </Formik>
            </DataView>
        </ContentLayout>
    )
}
